import * as form from '../../../library/form';
import { default as v } from './field-validations';
import * as c from './use-form-constants';

export default {
  ...form.fieldTypes,
  companyName: {
    ...form.defaultFieldState,
    name: c.COMPANY_NAME
  },
  country: {
    ...form.defaultFieldState,
    delayTime: 0,
    name: form.COUNTRY,
    validations: v.validateCountry
  },
  fleetAccountNumber: {
    ...form.defaultFieldState,
    delayTime: 500,
    name: c.FLEET_ACCOUNT_NUMBER,
    validations: v.validateFleetAccountNumber
  },
  state: {
    ...form.defaultFieldState,
    delayTime: 0,
    name: form.STATE,
    validations: v.validateState
  },
  zip: {
    ...form.defaultFieldState,
    name: form.ZIP,
    validations: v.validateZip
  }
};
